import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ProductoHistorial } from '../../../_models/producto-historial';
import { ProductoHistorialService } from '../../../_services/producto-historial.service';
import { Table } from 'primeng/table';
import { NavService } from '../../../_services/_nav.service';

@Component( {
  selector: 'app-producto-historial',
  templateUrl: 'producto-historial.component.html'
} )

export class ProductoHistorialComponent implements OnInit {

  @Input() producto: Producto;
  carTabla = true;
  lisProductosHistorial: ProductoHistorial[] = [];
  columnas: any[];
  @ViewChild('historial', { static: true }) tabla: Table;


  constructor( private proHistorialServicio: ProductoHistorialService, private navServicio: NavService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'fecha', header: this.navServicio.buscarMensaje( 'PRODUCTOHISTORIAL.LBL_FECHA' ), sort: false },
      { field: 'auditoriaUsuario', header: this.navServicio.buscarMensaje( 'PRODUCTOHISTORIAL.LBL_USUARIO' ), sort: false },
      { field: 'historial', header: this.navServicio.buscarMensaje( 'PRODUCTOHISTORIAL.LBL_HISTORIAL' ), sort: false }
    ];

    this.proHistorialServicio.listado().subscribe( historial => {
      this.lisProductosHistorial = historial;
      this.carTabla = false;
    } );
  }
}
